class UpdateProfileController {
    /*@ngInject*/
    constructor() {
        if (window.titles) {
            this.titles = window.titles.titles;
        }
        this.selectedTitle = '';
        this.title = {
            selected: null
        };
        this.requestPending = false;
    }

    titleChanged(item) {
        this.selectedTitle = item.code;
    }

    setTitleCode(code) {
        this.selectedTitle = code;
        for (let entry of this.titles) {
            if (code === entry.code) {
                this.title.selected = entry;
                break;
            }
        }
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default UpdateProfileController;
